<template>
    <div>

        <vue-headful title="Training Courses :: MeritEHS"/>

        <h4 class="py-3 mb-4">
            <ol class="breadcrumb font-weight-bold m-0">
                <li class="breadcrumb-item font-weight-light">
                    <router-link :to="`/training-courses`">
                        <i class="fa fa-graduation-cap"></i> Training Courses
                    </router-link>
                </li>
                <li class="breadcrumb-item active"><i class="fa fa-pause"></i> Pending Courses</li>
            </ol>
        </h4>

        <div class="card">
            <div class="card-body">
                <employee-training-list  ref="empPendingList" :courseType="'Pending'" :showDistributeButton="true"></employee-training-list>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        data: function() {
            return {

            }
        },

        methods: {

        },

        mounted(){
            //Focus on the SEarch Input
            this.$refs.empPendingList.$refs.empTrainingCourseTable.$refs.genericFilter.focus();
        },
    }
</script>
